import React from "react"
import PropTypes from "prop-types"
import exact from "prop-types-exact"

// The main hero block of text for the homepage.
// Takes a head, subhead and children.

const LeadBlock = ({ head, subhead, text, children }) => (
  <div className="lead-block">
    <h1>{head}</h1>
    {subhead && <h2>{subhead}</h2>}
    <p>{text}</p>
    {children}
  </div>
)

LeadBlock.propTypes = exact({
  children: PropTypes.node,
  head: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subhead: PropTypes.string,
  text: PropTypes.string,
})

LeadBlock.defaultProps = {
  subhead: null,
  children: null,
  text: null,
}

export default LeadBlock
